export const formValidation = ( state, t, notify ) => {
    if( !state.name || state.name.length === 0 || state.name === "" ){
        notify({ type: 'error', title: t('specialties.specialty'), text: t('notify.name') });
        return false;
    }

    return true
}